import makeGriffinServiceRequest from '../../services/makeGriffinServiceRequest';
import {
    ADD_REMOVE_OR_EDIT_URL_PREFIX,
    ADD_TO_CALENDAR_RELATIVEPATH,
} from '../../helpers/GriffinConstants';
/**
 * Handler for adding Txp event to calendar
 */
export default function onAddToCalendarClickHandler(itemId: string) {
    // TODO: Add timeout for griffin call VSTS#52270
    return makeGriffinServiceRequest(
        itemId,
        ADD_REMOVE_OR_EDIT_URL_PREFIX,
        ADD_TO_CALENDAR_RELATIVEPATH
    );
}
